<template>


    <!-- Hero Section -->
    <section class="hero-section">

        <HeroNavbar :lightToggler="true"/>
        <div class="hero-overlay">
            <div class="container">
                <h1 class="fw-bold title ">{{ $t('home.hero.title') }}</h1>
                <p class="lead">{{ $t('home.hero.description') }}</p>
                <a href="/dashboard/#/register-programs/quran" class="btn btn-primary btn-lg">{{ $t('home.hero.button') }}</a>
            </div>
        </div>
    </section>

    <!-- Statistics Section -->
    <!-- Statistics Section -->
    <section class="container mt-5">
        <div class="row text-center hero-stats">
            <div class="col-12 col-md-3 stat-item">
                <div class="stat-img">
                    <img src="@/assets/images/stats/img1.png" alt="">
                </div>
                <div class="stat-text">
                    <h3 class="fw-bold">{{ statics.students }}</h3>
                    <p> {{ $t('home.hero.total_students') }}</p>
                </div>
            </div>
            <div class="col-12 col-md-3 stat-item">
                <div class="stat-img">
                    <img src="@/assets/images/stats/img2.png" alt="">
                </div>
                <div class="stat-text">
                    <h3 class="fw-bold">{{ statics.course ? statics.course * 60 : '' }}</h3>
                    <p>  {{ $t('home.hero.total_hours') }}</p>
                </div>
            </div>
            <div class="col-12 col-md-3 stat-item">
                <div class="stat-img">
                    <img src="@/assets/images/stats/img3.png" alt="">
                </div>
                <div class="stat-text">
                    <h3 class="fw-bold">{{ statics.content }}</h3>
                    <p> {{ $t('home.hero.total_programs') }}</p>
                </div>
            </div>
            <div class="col-12 col-md-3 stat-item">
                <div class="d-flex align-items-center stat-item">
                    <div class="stat-img">
                        <img src="@/assets/images/stats/img4.png" alt="">
                    </div>
                    <div class="stat-text">
                        <h3 class="fw-bold">{{ statics.programs }}</h3>
                        <p>  {{ $t('home.hero.total_program_students') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Social Icons -->
    <div class="social-icons" :style="this.$i18n.locale === 'ar' ? 'left: 40px;' : 'right:40px;'">
        <a href="#" target="_blank"><img src="@/assets/images/social/x.png" /></a>
        <a href="#" target="_blank"><img src="@/assets/images/social/instagram.png" /></a>
        <a href="#" target="_blank"><img src="@/assets/images/social/youtube.png" /></a>
    </div>
</template>
<script>
import HeroNavbar from '../HeroNavbar.vue';

export default {
    props: {
        statics: {
            type: Object, // Adjust type based on your data structure
            required: true // Set to false if it's optional
        }
    },
    components: {
        HeroNavbar
    }

};
</script>
<style scoped>
.title {
    font-size: 44px;
    font-weight: 500;
}

.lead {
    margin-top: 40px;
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: 400;
}

.hero-section {
    background: url('@/assets/images/hero.webp') no-repeat 100%;
    background-position: top center;
    background-size: cover;
    height: 812px;
    position: relative;
    color: white;
    text-align: center;
    z-index: 0;
    /* Lower than buttons & links */
}

.hero-overlay {
    background: rgba(0, 0, 0, 0.4);
    /* Darker overlay for better contrast */
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    position: absolute;
    /* Ensure it doesn't affect the stats */
    top: 0;
    left: 0;
    width: 100%;
    z-index: 0;
    /* Lower than buttons & links */


}

.hero-overlay .container {
    position: relative;
    z-index: 2;
    /* Ensures content is above overlay */
    max-width: 673px;
    text-align: start;
    margin-inline-start: 0;
    /* Ensures it starts from the left */
    padding-inline-start: 20vh;
    /* Adds space from the edge */
}


.hero-stats {
    background: white;
    border-radius: 10px;
    padding: 20px;
    margin-top: -120px;
    /* Adjust as needed */
    position: relative;
    /* Keeps it above hero-overlay */
    z-index: 2;
    /* Ensures it's on top */
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.10);
    /* Soft shadow effect */
    height: 175px;
}

.social-icons {
    position: absolute;
    top: 30%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.social-icons a {
    display: block;
    width: 40px;
    height: 40px;
    background: white;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    color: #333;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
    transition: 0.3s;
}

.social-icons a:hover {
    background: #f8b400;
    color: white;
}



.social-icons a img {
    height: 20px;
    width: auto;
    position: relative;
    bottom: 2px;
}



.stat-item {
    display: flex;
    align-items: center;
    /* Aligns image and text vertically */
    gap: 13px;
    /* Adds space between image and text */
}

.stat-img img {
    width: 60px;
    /* Adjust as needed */
    height: auto;
    display: block;
    position: relative;
    bottom: 6px;
}

.stat-text {
    display: flex;
    flex-direction: column;
    /* Ensures text stays stacked */
    justify-content: center;
    /* Centers text vertically */
}

.stat-text h3 {
    font-weight: 700;
    font-size: 24px;
}

.stat-text p {
    font-weight: 400;
    font-size: 15px;
}



.break {
    width: 2px;
    height: 25px;
    background-color: #FFFFFF52;
}

/* Add this to your existing styles */
@media (max-width: 767.98px) {
    .hero-stats {
        margin-top: -60px;
        /* Adjust as needed for mobile */
        padding: 10px;
        /* Reduce padding for mobile */
        height: auto;
        /* Allow height to adjust based on content */
    }

    .stat-item {
        flex-direction: column;
        /* Stack image and text vertically */
        gap: 10px;
        /* Adjust gap between image and text */
        margin-bottom: 20px;
        /* Add space between stacked items */
    }

    .stat-img img {
        width: 50px;
        /* Adjust image size for mobile */
        bottom: 0;
        /* Reset positioning */
    }

    .stat-text h3 {
        font-size: 20px;
        /* Adjust font size for mobile */
    }

    .stat-text p {
        font-size: 14px;
        /* Adjust font size for mobile */
    }

    .social-icons {
        display: none;
    }
}

@media (min-width: 1720px) {  
    .hero-overlay .container {  
        max-width: 900px;  
        padding-inline-start: 40vh;
    }  
}

@media (max-width: 768px) {
  .hero-overlay .container {
    padding-inline-start: 20px;
  }
}


</style>